/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import {
    Configuration,
    ConfigurationParameters,
    QuickMenuApi,
    QuickMenuShortcut,
    QuickMenuShortcutsGetRequest,
} from 'client-code/homeshortcut';

import { APPLICATION_FEATURE_AREA } from '../../config';
import { CommonHeaders } from '../CommonHeaders';
import { Constants } from '../constants';
import { IQuickMenuShortcutServiceRepository } from '../interfaces/IQuickMenuShortcutServiceRepository';
import { Log } from '../logging';
import { TServicesParams } from '../types';

export class QuickMenuShortcutServiceRepositoryImpl implements IQuickMenuShortcutServiceRepository {
    private static TAG: string = 'QuickMenuShortcutServiceRepositoryImpl';

    private mServiceParams: TServicesParams;

    public constructor(params: TServicesParams) {
        this.mServiceParams = params;
    }

    /**
     * @inheritdoc
     */
    public async fetchQuickMenuShortcuts(): Promise<QuickMenuShortcut[]> {
        try {
            const commonHeaders = new CommonHeaders(APPLICATION_FEATURE_AREA.GUIDE).headers;
            const configurationParameters: ConfigurationParameters = {
                basePath: this.mServiceParams.basePath,
                apiKey: this.mServiceParams.accessToken,
                baseOptions: {
                    timeout: Constants.SERVICE_CONNECTION_TIMEOUT,
                    headers: commonHeaders,
                },
            };
            const configuration = new Configuration(configurationParameters);
            const quickMenuApi = new QuickMenuApi(configuration);
            const requestParams: QuickMenuShortcutsGetRequest = {
                applicationName: commonHeaders.ApplicationName,
                applicationFeatureArea: commonHeaders.ApplicationFeatureArea,
                applicationVersion: commonHeaders.ApplicationVersion,
                deviceType: commonHeaders.DeviceType,
                productName: commonHeaders.ProductName,
                bodyId: this.mServiceParams.bodyId,
                acceptLanguage: commonHeaders['Accept-Language'],
                whiny: this.mServiceParams.whiny || 'false',
            };

            const quickMenuResponse = await quickMenuApi.quickMenuShortcutsGet(requestParams);
            return quickMenuResponse.data;
        } catch (error) {
            Log.e(QuickMenuShortcutServiceRepositoryImpl.TAG, 'fetchQuickMenuShortcut', error);
            throw error;
        }
    }
}
